module.exports = __webpack_public_path__ + "img/contact1.e9985036.png";